import { render, staticRenderFns } from "./view-editor.vue?vue&type=template&id=6629dbcc&scoped=true"
import script from "./view-editor.vue?vue&type=script&lang=js"
export * from "./view-editor.vue?vue&type=script&lang=js"
import style0 from "./view-editor.vue?vue&type=style&index=0&id=6629dbcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6629dbcc",
  null
  
)

export default component.exports